export default {
  root: {
    backgroundColor: "#FFFF",
    "& .MuiTab-root": {
      minWidth: 140
    }
  }
};
